import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "default" | "minimal"
  showPasswordToggle?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", showPasswordToggle = false, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const inputType = type === "password" && showPassword ? "text" : type

    if (variant === "minimal") {
      return (
        <div className="relative">
          <input
            type={inputType}
            className={cn(
              "flex h-11 w-full rounded-xl border-2 border-input bg-transparent px-4 py-1.5 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-primary/50 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:shadow-sm focus-visible:shadow-primary/5 disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50",
              className
            )}
            ref={ref}
            {...props}
          />
          {type === "password" && showPasswordToggle && (
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-all duration-200 p-1 rounded hover:bg-accent/50"
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          )}
        </div>
      )
    }

    return (
      <div className="relative">
        <input
          type={inputType}
            className={cn(
              "flex h-11 w-full rounded-xl border-2 border-input bg-background px-4 py-1.5 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-primary/50 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:shadow-sm focus-visible:shadow-primary/5 disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50",
              className
            )}
          ref={ref}
          {...props}
        />
        {type === "password" && showPasswordToggle && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-all duration-200 p-1 rounded hover:bg-accent/50"
          >
            {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
